import { Component } from '@angular/core';
import { LegalModal, LegalDocType } from './legal-modal/legal-modal';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [LegalModal],
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss']
})
export class Footer {

  /** Which legal document is currently open in the modal. Null = closed. */
  activeLegalDoc: LegalDocType | null = null;

  openLegal(doc: LegalDocType): void {
    this.activeLegalDoc = doc;
  }

  closeLegal(): void {
    this.activeLegalDoc = null;
  }

  scrollTo(id: string): void {

    const el = document.getElementById(id);

    if (el) {

      const headerOffset = 160;

      const elementPosition =
        el.getBoundingClientRect().top;

      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

    } else if (id === 'home') {

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

    }
  }

}